import React , { useState } from 'react'

import AsyncSelect from 'react-select/async';

import { ApiCallGet , ApiCallPost } from '../ApiCall/ApiCall';

import Monedas from '../Monedas/Monedas';




export default function Divisas() {

    const [precio, setPrecio] = useState("0")
    const [fechaToday,setFechaToday] = useState( "" )
    const [divisa, setDivisa] = useState( "" )
    const [addDivisa, setAddDivisa] = useState( false )
    const [candidate,setCandidate] = useState( "" )
    const [showMonedas,setShowMonedas] = useState( false )
    //const [theFechaFinal,setTheFechaFinal] = useState( null )

    function onDone()
    {
        setShowMonedas( false ) ; // Dejamos de ver las monedas
    }
   

    function onSetMoneda()
    {
         console.log( "addDivisa = " + addDivisa )
    }

    function onCuentaChange( val )
    {
        console.log("onCuentaChange*** = ", val)

       

        setDivisa( val ) // { value , label }

        // id = val.value 

        // cluentacliente 105.01FOBL7

        //setCuenta( val )

    }

    function onSubmit( e )
    {
        e.preventDefault()


        console.log("addDivisda*** = ", document.getElementById('buttonadd').innerText )

        if ( fechaToday === "")
        {
            alert("Seleccione una fecha")
            return
        }

        if ( divisa === "")
        {
            alert("Seleccione una divisa")
            return
        }

        if ( precio === "0")
        {
            alert("Seleccione un precio")
            return
        }

        console.log("onSubmit")
        console.log("fechaToday = ", fechaToday  + "    divisa = ", divisa.label ) 
        console.log("precio = ", precio)

        var body = {
            fecha : fechaToday ,
            idmoneda : divisa.value ,
            valor : precio ,
            dTimeStamp : new Date()
        }

        console.log( "divisa = " + body )

        ApiCallPost( "savedivisa" , body ) // savedivisa
        .then( (response) => {

            console.log("response = ", response) // Nos regresa el id donde se guardo

            alert("Divisa guardada")


        })
        .catch( (error) => {

            console.log("error = ", error)

            alert("Error al guardar la divisa")

        })
    }

    const onPrecioChange = (e) => {
        const precio2 = e.target.value;

        //console.log("precio2 = ", precio2)

        if (!precio2 || precio2.match(/^\d{1,}(\.\d{0,4})?$/)) {
          //console.log( "setprecio")
          setPrecio(precio2)
        }
      };

    function setFechaVigencia( val )
    {
        console.log("setFechaVigencia = ", val)

        //console.log("fechaToday = ", fechaToday)

        setFechaToday( val )
    }

    // function setFechaFinal( val )
    // {
    //     console.log("setFechaVigencia = ", val)

    //     //console.log("fechaToday = ", fechaToday)

    //     setTheFechaFinal( val )
    // }


    function setInputValue(val){
        console.log("setInputValue = ", val)

        if ( val === "")
        {

            var letrero = document.getElementById('buttonadd').innerText

            console.log("addDivisda*** = ", letrero )
            console.log( "candidate = " + candidate )

            if ( letrero === "AGREGAR MONEDA")
            {
                setShowMonedas( true )
                return ;
            }

            setAddDivisa( false )
        }
    }

    const loadOptions = (inputValue, callback) => {

        console.log("inputValue ( load options ) = ", inputValue)

        setCandidate( inputValue )


        ApiCallGet( 'getmonedas/?moneda='+ inputValue )
        .then( (response) => {

            console.log("descuento = ", response)

            var arr = []

            console.log("response.length = ", response.length )

            if ( response.length > 0 )
            {

                for( var i = 0 ; i < response.length ; i++ )
                {
                    var item = response[i]

                    //console.log("item = ", item)

                    var obj = { value : item.idcat_moneda , label : item.c_moneda + " " + item.descripcion }

                    arr.push( obj )
                }
                
            }

            console.log("arr = ", arr)

            if ( arr.length === 0 )
            {
                setAddDivisa( true )
            }
            else{
                setAddDivisa( false )
            }

            callback( arr ) // Regresamos el arreglo de las divisas seleccionadas

            

        })
        .catch( (error) => {

            console.log("error = ", error)

        })
    


        

    }



  return (
    <div className='box-1 backemployer-2 centersearch w-100 m-1 align-items-center' >
    <div className='d-flex flex-column  box-1 backemployer-2 mb-5 form-2 w-100' 
     id="page1" style={{fontSize:'16px' , margin :'auto'}} >

        <div className='row'>
              <div className='col-sm-8'>
                <h5>Administrador de Divisas</h5>
              </div>
        </div>

        <form onSubmit={onSubmit} hidden={showMonedas}>

            <div className='row'>
                <div className='col-4 '>
                    <label className="form-label m-0" htmlFor="fechacita">Fecha Vigencia</label>
                    <input style={{height:'40px'}} type="date" 
                    className="form-control pt-3 mt-2" id="fechacita" onChange={(e) => setFechaVigencia(e.target.value)} />
                </div>


                <div className='col-sm-4'>
                    <div className="form-group"  style={{width: "100%" }} >
                        <label className="form-label m-0" htmlFor="moneda">Moneda</label>

                        <AsyncSelect className='pt-2'
                            id="moneda" cacheOptions
                            loadOptions={loadOptions} onChange={onCuentaChange}
                            onInputChange={(value) => setInputValue(value)} placeholder="Moneda"/>
                    </div>
                </div>

                        
                <div className={ 'col-sm-4'}>
                            <label className="form-label m-0" htmlFor="precio">Valor</label>
                            <input type="text" className="form-control" id="precio" onChange={onPrecioChange} value={precio}
                            style={{marginTop:6,height:'40px'}}/>

                </div>
                    
                


            </div>
            {/* <div className='row '>

                <div className='col-4'>

                </div>

                <div className='col-4 '>
                    <label className="form-label m-0" htmlFor="fechafin">Fecha Final</label>
                    <input style={{height:'40px'}} type="date" 
                    className="form-control pt-3 mt-2" id="fechafin" onChange={(e) => setFechaFinal(e.target.value)} />
                </div>

            </div> */}


            <div className='row mt-5'>

                    <button type='submit' className="btn btn-primary mt-3 button-3 w-25 m-auto"
                        style={{ backgroundColor: ( addDivisa?'blue' : 'green' )}} id='buttonadd'
                        >{addDivisa ? "Agregar Moneda" : "Agregar Divisa"}</button>
                    
            </div> 

            
        </form>
        {
            showMonedas && (
                <Monedas moneda={candidate} done={onDone} 
                    fechaToday={fechaToday}></Monedas>
            )
        }
        
    </div>
    </div>
  )


}
